import {
  AccountDetail,
  AccountDetailSchema,
  AccountType,
  ActivationInfoDto,
  ActivationStatus,
  ActivationType,
  ApiRoute,
  SystemRole,
  SystemRoleSchema,
  getApiRoute
} from "@humanex/interfaces";
import { z } from "zod";

import { ApiClientConfig, BaseApiClient } from "./base-client";

export interface AccountStatusResp {
  activationStatus: ActivationStatus;
  accountType: AccountType;
}

export interface AccountRequestResponse {
  checkoutUrl: string;
  qrCode: string;
}

export class AccountApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.ACCOUNT),
      requireAuth: true
    });
  }

  async getStatus(type: ActivationType): Promise<ActivationInfoDto.Type> {
    return this.get("activation", ActivationInfoDto.Schema, {
      params: { type }
    });
  }

  async requestActivation(type: ActivationType): Promise<AccountRequestResponse> {
    return this.post("activation", z.object({ checkoutUrl: z.string(), qrCode: z.string() }), { type });
  }

  async setReferral(code: string): Promise<void> {
    return this.post("referral", z.void(), { code });
  }

  async getParent(): Promise<AccountDetail | null> {
    return this.get("parent", AccountDetailSchema.nullable());
  }

  async getRoles(): Promise<SystemRole[]> {
    return this.get("roles", z.array(SystemRoleSchema));
  }
}
